import React from 'react';

export default function HydrologyInfo() {
  return (
    <>
      <h2 className="text-lg font-semibold mb-4">Hydrology</h2>
      <p className="text-sm text-gray-700 mb-4">
        Analyze hydrology data configured in the BMP Selection tab. You must first select BMPs using the BMP Selection tab. 
      </p>

      <p className="text-sm text-gray-700 mb-4">
        Select the <b>Flow and Volume Reduction</b> tab below to explore data distributions using jigger box and whisker plots and percent change efficiencies between inflow and outflow. 
      </p>
      <p className="text-sm text-gray-700 mb-4">
        Select the <b>Performance Index</b> tab below to explore how well the BMP(s) capture and retain runoff compared to design expectations. 
      </p>
    </>
  );
}
